import { http } from './config/config-receituario'
import { httpApiV2 } from './config/config-receituario-v2'
import { httpApiSisDev } from './config/config-sisdev'
import axios from 'axios'
import ItemReceita from './request/item-receita'
import moment from 'moment'
moment.locale('pt-br')

const httpNewApi = axios.create({
  baseURL:
    process.env.VUE_APP_API_RECEITUARIO ||
    'https://newapi.webreceita.com.br/webreceita/api/v1',
})

export default {
  listar: (token, take = 10, page = 0) => {
    return http.get('receitas?take=' + take + '&page=' + page, {
      headers: {
        Authorization: token,
      },
    })
  },
  listarByFilter: (
    token,
    numero_receita,
    status,
    dtInicial,
    dtFinal,
    produtorId,
    agronomoId,
    cpfcnpj_produtor,
    take,
    page
  ) => {
    const params = []

    if (numero_receita != undefined && numero_receita.length > 0) {
      params.push('&numero_receita=' + encodeURIComponent(numero_receita))
    }
    if (status != undefined && status.length > 0) {
      params.push('&status=' + encodeURIComponent(status))
    }
    if (dtInicial != undefined && dtInicial.length > 0) {
      // const dataInicial = moment(dtInicial, 'DD/MM/YYYY', true).format(
      //   'YYYY-MM-DD'
      // )
      params.push('&data_inicial=' + encodeURIComponent(dtInicial))
    }
    if (dtFinal != undefined && dtFinal.length > 0) {
      //const dataFinal = moment(dtFinal, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
      params.push('&data_final=' + encodeURIComponent(dtFinal))
    }
    if (produtorId != undefined) {
      params.push('&id_produtor_rural=' + encodeURIComponent(produtorId))
    }
    if (agronomoId != undefined) {
      params.push('&id_agronomo=' + encodeURIComponent(agronomoId))
    }
    if (cpfcnpj_produtor != undefined && cpfcnpj_produtor != '') {
      params.push('&cpfcnpj_produtor=' + encodeURIComponent(cpfcnpj_produtor.replace(/\D/g, "")))
    }
    if (take != undefined) {
      params.push('&take=' + encodeURIComponent(take))
    }
    if (page != undefined) {
      params.push('&page=' + encodeURIComponent(page))
    }
    //console.log(params);

    const param = params.join('')
    return http.get(`receitas/filter?${param}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  findById: (token, idReceita) => {
    return http.get('receitas/' + idReceita, {
      headers: {
        Authorization: token,
      },
    })
  },
  deletar: (token, idReceita) => {
    return httpApiV2.delete('receitas/' + idReceita, {
      headers: {
        Authorization: token,
      },
    })
  },
  editarNumeracao: (token, idReceita, data) => {
    return http.put(`receitas/editar-numeracao/${idReceita}`, data, {
      headers: {
        Authorization: token,
      },
    })
  },
  rebuild: (token, idReceita, data) => {
    return http.put(`receitas/rebuid-receita/${idReceita}`, data, {
      headers: {
        Authorization: token,
      },
    })
  },
  consultarReceita: (token, idReceita) => {
    return httpApiV2.get('receitas/' + idReceita, {
      headers: {
        Authorization: token,
      },
    })
  },
  consultarProduto: (token) => {
    return httpApiV2.get('produtos', {
      headers: {
        Authorization: token,
      },
    })
  },
  consultarCultura: (token) => {
    return httpApiV2.get(`culturas`, {
      headers: {
        Authorization: token,
      },
    })
  },
  consultarCulturaPorProduto: (token, produto) => {
    return httpApiV2.get(`culturas/produto/${produto}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  consultarAlvoPorProdutoCultura: (token, cultura, produto) => {
    return httpApiV2.get(`alvos/${cultura}/${produto}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  consultaFitossanitaria: (token, produto) => {
    return httpApiV2.get(`fito/${produto}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  consultarRelacao: (token, produto, cultura, alvo, produtor) => {
    return httpApiV2.get(`receitas/${produto}/${cultura}/${alvo}/${produtor}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  abrirReceita: async (token, receita) => {
    return httpApiV2.post('receitas', receita, {
      headers: {
        Authorization: token,
      },
    })
  },
  addItemReceita: async (token, item) => {
    return httpApiV2.post('receitas/item', item, {
      headers: {
        Authorization: token,
      },
    })
  },
  delItemReceita: (token, id) => {
    return httpApiV2.delete(`receitas/item/${id}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  consultarItemReceita: async (token, id) => {
    return httpApiV2.get(`receitas/${id}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  emitir: async (token, data) => {
    return httpApiV2.put('receitas', data, {
      headers: {
        Authorization: token,
      },
    })
  },
  calcularArea: async (token, payload) => {
    return httpNewApi.post('calculos/aplicacao', payload, {
      headers: {
        Authorization: token,
      },
    })
  },
  validarProdutosPorReceita: async (token, payload) => {
    return httpNewApi.post('regras/produtos-por-receita/validar', payload, {
      headers: {
        Authorization: token,
      },
    })
  },

  revenueSignature: async (token, data) => {
    return http.put(`receitas/signatures/${data.id}`, data, {
      headers: {
        Authorization: token,
      },
    })
  },
  signDigital: async (token, data) => {
    return httpApiV2.post('digital-signature', data, {
      headers: {
        Authorization: token,
      },
    })
  },
  noSignDigital: async (token, data) => {
    return httpApiV2.post('digital-no-signature', data, {
      headers: {
        Authorization: token,
      },
    })
  },
  enviarEmailReceita: async (token, idReceita) => {
    return http.post(`receitas/${idReceita}/enviar-email`, null, {
      headers: {
        Authorization: token,
      },
    });
  },
  emitirReceitaV2: async (token, receita) => {
    return http.post(`receituario/pdf`, receita, {
      headers: {
        Authorization: token,
      },
    });
  },
  enviarWebhookSisdev: async (payload) => {
    return httpApiSisDev.post('sisdev', {
      ...payload,
    })
  },
  buscarProdutosTorge: async (token, query = {}) => {
    const filtro = query && query.filtro ? query.filtro : ''

    return http.get('integrations/torge/produtos', {
      headers: {
        Authorization: token,
      },
      params: {
        filtro,
        campo: 'todos',
        ativo: 'sim',
        composicoes: false,
        numeroregistros: 12,
        registroinicial: 0,
        campoordenacao: 0,
        ordenacao: -1,
        status: 'todos',
      },
    })
  },
  enviarFaturamentoTorge: async (token, idReceita, payload = {}) => {
    return http.post(`integrations/torge/faturamentos/receitas/${idReceita}`, payload, {
      headers: {
        Authorization: token,
      },
    })
  },
}
